export default __webpack_public_path__ + "static/media/pwc-logo.f54e241c.svg";